import { isEmptyOrWhitespace, styled } from "@shoothill/core";
import { useObserver } from "mobx-react-lite";
import React, { useState } from "react";
import { InductionAdminViewModel } from "../InductionAdminViewModel";
import MaterialTable from "material-table";
import { DarwinTablePageContent } from "Globals/Styles/AppStyling";
import { formatDate, formatTime } from "Utils/Format";
import { SHBox } from "Components/Box";
import { PatchedPagination } from "Components/Table/PatchedPagination";
import * as Defaults from "Globals/Defaults/TableOptions";
import { InductionAdminNearMissItemDTO } from "./InductionAdminNearMissModel";
import { InductionAdminNearMissViewModel } from "./InductionAdminNearMissViewModel";

interface IProps {
    className?: string;
    viewModel: InductionAdminViewModel;
    inductionUserId: string;
}

const InductionAdminNearMissViewBase: React.FC<IProps> = (props) => {
    const { viewModel, inductionUserId } = props;
    const [listViewModel] = useState(() => new InductionAdminNearMissViewModel(inductionUserId));
    // #region Code Behind

    const renderPage = () => {
        return (
            <DarwinTablePageContent>
                <MaterialTable
                    columns={[
                        { title: "Type of incident", field: "incidentFormTypeName" },
                        {
                            title: "Date / time added",
                            field: "createdDate",
                            render: (rowData: InductionAdminNearMissItemDTO) => (
                                <SHBox>
                                    <SHBox>{rowData.createdDate ? `${formatDate(rowData.createdDate.toString())} @ ${formatTime(rowData.createdDate.toString())}` : ""}</SHBox>
                                </SHBox>
                            ),
                        },
                        { title: "Location", field: "location" },
                        {
                            title: "Investigation report added",
                            field: "isInvestigationReportAdded",
                            render: (rowData: InductionAdminNearMissItemDTO) => (
                                <SHBox>
                                    <SHBox>{rowData.isInvestigationReportAdded}</SHBox>
                                </SHBox>
                            ),
                        },
                        {
                            title: "Last updated",
                            field: "lastUpdatedDate",
                            render: (rowData: InductionAdminNearMissItemDTO) => (
                                <SHBox>
                                    <SHBox>
                                        {formatDate(rowData.lastUpdatedDate.toString())} @ {formatTime(rowData.lastUpdatedDate.toString())} by
                                    </SHBox>
                                    <SHBox>{`${rowData.lastUpdatedByUserName}`}</SHBox>
                                </SHBox>
                            ),
                        },
                    ]}
                    components={{
                        Pagination: PatchedPagination,
                    }}
                    options={Defaults.GetDarwinTableOptions()}
                    data={listViewModel.incidentItemList}
                    onRowClick={(e, rowData) => {
                        listViewModel.handleRowClick(e, rowData!);
                    }}
                    title=""
                />
            </DarwinTablePageContent>
        );
    };

    return useObserver(() => renderPage());
};

export const InductionAdminNearMissView = styled(InductionAdminNearMissViewBase)``;
